import type { RouteRecordRaw } from 'vue-router';
import { batchPaymentsRoutes } from './send-money/batch-payments/batch-payments.routes';
import {
  PAYMENT_PROCESSED_ROUTE_NAME,
  SEND_MONEY_ADD_CONTACT_ROUTE_NAME,
  SEND_MONEY_ROUTE_NAME,
} from './send-money/internal/send-money.constants';

export const moneyRoutes = [
  {
    path: 'add-money',
    name: 'add-money',
    component: () => import('./add-money/AddMoneyPage.vue'),
    meta: { title: 'Add Money' },
  },
  {
    path: 'send-money/add-contact',
    name: SEND_MONEY_ADD_CONTACT_ROUTE_NAME,
    component: () => import('./send-money/add-contact/AddContactPage.vue'),
    meta: { title: 'Add Contact' },
  },
  {
    path: 'send-money',
    name: SEND_MONEY_ROUTE_NAME,
    component: () => import('./send-money/SendMoneyPage.vue'),
    meta: { title: 'Send Money' },
  },
  ...batchPaymentsRoutes,
  {
    path: 'send-money',
    name: 'send-money-flow',
    component: () => import('./send-money/SendMoneyLayout.vue'),
    children: [
      {
        path: 'new-recipient/:step([1-9])',
        name: 'new-recipient',
        component: () => import('./send-money/SendMoneyFlowPage.vue'),
        meta: { title: 'New Recipient' },
      },
      {
        path: 'existing-contact/:step([1-9])',
        name: 'existing-contact',
        component: () => import('./send-money/SendMoneyFlowPage.vue'),
        meta: { title: 'Existing Contact' },
      },
      {
        path: 'myself/:step([1-9])',
        name: 'myself',
        component: () => import('./send-money/SendMoneyFlowPage.vue'),
        meta: { title: 'Myself' },
      },
      {
        path: 'payment-processed',
        name: PAYMENT_PROCESSED_ROUTE_NAME,
        component: () => import('./payment-processed/PaymentProcessed.vue'),
        meta: { title: 'Payment Processed' },
      },
    ],
  },
] as const satisfies readonly RouteRecordRaw[];
